class Folder {
    page: number;
    itemsPerPage: number;
    filter: string;
    totalItems: number;
    constructor(){
        this.page = 1;
        this.itemsPerPage = 6;
        this.totalItems = 0;
        this.filter = "";
    }
}

export default Folder;